var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",attrs:{"id":"app"}},[_c('Header',{on:{"muteds":function($event){return _vm.muterds($event)}}}),_c('div',{style:({'height':_vm.height})}),_c('router-view',{attrs:{"muted":_vm.muted}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }